/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const skill_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "name",
        defaultDisplayPreferences: {
            order: 1,
            size: 200,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
    {
        id: "description",
        defaultDisplayPreferences: {
            order: 2,
            size: 300,
            visible: true,
            displayAs: "string",
            pinned: false,
        },
    },
];
